import React, {useState, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import Axios from "axios";
// Assets
import "./styles.scss";
import modalFile from "../../../../assets/icons/modalFile.svg";
import fileUpload from "../../../../assets/icons/filesUpload.svg";
import downloaded from "../../../../assets/icons/downloaded.svg";
import basket from "../../../../assets/icons/basket.svg";
// Utils
import getCurrentDateDdMmYy from "../../../../utils/getCurrentDate-dd-mm-yy";
import {getApiBaseUrl} from "../../../../utils/baseUrl";

// Composant créé sur la base de cet article : https://blog.logrocket.com/create-a-drag-and-drop-component-with-react-dropzone/
// Il est un peu complexe alors ne pas hésiter à consulter le lien ci-dessus pour mieux comprendre comment il a été construit
const UploadFile = ({
                        idCase,
                        setShowModalNoRerender,
                        setSuccessUploadMess,
                        setErrorUploadMess,
                        postDocumentAsMessage,
                        getDocuments,
                        getMessages
                    }) => {

    // On stock les tous les fichier dans un array
    const [selectedFiles, setSelectedFiles] = useState([]);
    // Message d'erreur pour les fichier non pris en charge
    const [errorMessage, setErrorMessage] = useState("");
    // On stock les fichiers valides dans un array
    const [validFiles, setValidFiles] = useState([]);
    const [unsupportedFiles, setUnsupportedFiles] = useState([]);
    const fileInputRef = useRef();

    const uploadModalRef = useRef();
    const uploadRef = useRef();
    const progressRef = useRef();

    useEffect(() => {
        let filteredArray = selectedFiles.reduce((file, current) => {
            const x = file.find(item => item.name === current.name);
            if (!x) {
                return file.concat([current]);
            } else {
                return file;
            }
        }, []);
        setValidFiles([...filteredArray]);
    }, [selectedFiles]);


    const dragOver = (e) => {
        e.preventDefault();
    };

    const dragEnter = (e) => {
        e.preventDefault();
    };

    const dragLeave = (e) => {
        e.preventDefault();
    };

    const handleFiles = (files) => {
        for (let i = 0; i < files.length; i++) {
            if (validateFile(files[i])) {
                // Si le fichier est valide, on l'ajoute à un array pour pouvoir l'afficheer
                setSelectedFiles(prevArray => [...prevArray, files[i]]);
            } else {
                // ON ajoute une nouvelle propriété pour les fichiers invalides
                files[i]["invalid"] = true;
                // ON l'ajoute au même tableau que ci-dessus, mais on affichera message indiquant que le fichier
                // n'est pas pris en charge grâce à la propriété "invalid"
                setSelectedFiles(prevArray => [...prevArray, files[i]]);
                setUnsupportedFiles(prevArray => [...prevArray, files[i]]);
                // Le message d'erreur à afficher pour les fichier non pris en charge
                setErrorMessage("Type de fichier non autorisé");
            }
        }
    };

    // Définition des types de fichier pris en charge
    const validateFile = (file) => {
        const validTypes = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "image/gif",
            "image/x-icon",
            "image/svg+xml",
            "image/bmp",
            "image/tiff",
            "text/plain",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "text/csv",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        // Si l'extension de fichier n'est pas trouvé dans le tableau (renvoie -1) alors on return false
        if (validTypes.indexOf(file.type) === -1) {
            return false;
        }
        return true;
    };

    const fileDrop = (e) => {
        // Au moment de glisser déposer un fichier, on exécute la fonction handleFiles
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files.length) {
            handleFiles(files);
        }
    };

    const removeFile = (name) => {
        // find the index of the item
        // remove the item from array
        const validFileIndex = validFiles.findIndex(e => e.name === name);
        validFiles.splice(validFileIndex, 1);
        // update validFiles array
        setValidFiles([...validFiles]);
        const selectedFileIndex = selectedFiles.findIndex(e => e.name === name);
        selectedFiles.splice(selectedFileIndex, 1);
        // update selectedFiles array
        setSelectedFiles([...selectedFiles]);

        const unsupportedFileIndex = unsupportedFiles.findIndex(e => e.name === name);
        if (unsupportedFileIndex !== -1) {
            unsupportedFiles.splice(unsupportedFileIndex, 1);
            // update unsupportedFiles array
            setUnsupportedFiles([...unsupportedFiles]);
        }
    };

    const fileInputClicked = () => {
        fileInputRef.current.click();
    };

    const filesSelected = () => {
        if (fileInputRef.current.files.length) {
            handleFiles(fileInputRef.current.files);
        }
    };
    const url = `${getApiBaseUrl()}/postDocuments/`;

    const uploadFiles = () => {
        setSuccessUploadMess("");
        setErrorUploadMess("");
        // On sélectionne le formulaire d'upload
        let data = document.querySelector("#uploadDocuments");
        // On créer un nouvel objet FromData https://developer.mozilla.org/fr/docs/Web/API/FormData
        const formData = new FormData(data);
        // Dans lequel on attache tous les fichiers valides
        for (let i = 0; i < validFiles.length; i++) {
            formData.append("documents[" + i + "]", validFiles[i]);
        }
        // La requête API n'est pas dans un middleware par soucis de facilité. On pourrait exporté cette logique
        // Dans un middleware, il faudrait alors stocker le formData dans le store grâce à une action déclencer dans un reducer
        Axios.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
            .then((res) => {
                if (res) {
                    const firstPostDocument = async () => {
                        // Affiche le document dans la partie messagerie
                        await postDocumentAsMessage(res.data.id);
                    };
                    firstPostDocument().then(() => {
                        // On ferme la modal
                        setShowModalNoRerender(false);
                        // Puis on refresh la liste de message
                        getMessages();
                        // Ainsi que la liste des document
                        getDocuments();
                    });
                    // Message de succès
                    setSuccessUploadMess("Le téléchargement des fichiers a bien été effectué.");
                    // On vide le message de succès 4 secondes après
                    setTimeout(() => {
                        setSuccessUploadMess("");
                    }, 4000);
                }
            })
            .catch((err) => {
                if (err.response.status === 406) {
                    // En cas d'erreur 406, on notifie le user
                    setErrorUploadMess("Une erreur est survenue lors du téléchargement des fichiers.");
                    setTimeout(() => {
                        setErrorUploadMess("");
                    }, 4000);
                }
            });
    };

    const closeUploadModal = () => {
        uploadModalRef.current.style.display = "none";
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <div className="content">
                <p className="title">Ajouter un document</p>
                <div className="container-modal">
                    <div
                        className="drop-container"
                        onClick={fileInputClicked}
                        onDragOver={dragOver}
                        onDragEnter={dragEnter}
                        onDragLeave={dragLeave}
                        onDrop={fileDrop}
                    >
                        <img className="modalFile" src={modalFile} alt=""/>
                        <div className="drop-message">
                            Déposez votre fichier ici ou <span>cliquez ici</span> pour télécharger
                        </div>
                        <div className="sub-drop-message">
                            Formats autorisés jpeg, png, pdf
                        </div>
                        <form encType="multipart/form-data" onSubmit={handleSubmit} id="uploadDocuments">
                            <input
                                ref={fileInputRef}
                                className="file-input"
                                type="file"
                                multiple
                                onChange={filesSelected}
                                name="documents"
                            />
                            {/*Input hidden dans lesquels on définit les valeurs de la session*/}
                            {/*Ils seront attachés au FormData*/}
                            <input
                                type="hidden"
                                name="idUser"
                                value={window.localStorage.idUser}
                            />
                            <input
                                type="hidden"
                                name="id"
                                value={window.localStorage.id}
                            />
                            <input
                                type="hidden"
                                name="email"
                                value={window.localStorage.email}
                            />
                            <input
                                type="hidden"
                                name="idCase"
                                value={idCase}
                            />
                        </form>
                    </div>
                    {validFiles.map((data, index) =>
                        // Affichage des fichiers ajouter par le user
                        <div className="filesContainer" key={index}>
                            <img className="fileIcon" src={fileUpload} alt=""/>
                            <div className="filesInfos">
                                <p className="fileName">{data.name.length < 10 ? data.name : data.name.slice(0, 10) + "..."}</p>
                                <p className="uploadDate">Ajouté le {getCurrentDateDdMmYy()}</p>
                            </div>
                            {data.invalid &&
                                <span className='fileErrorMessage'>{errorMessage}</span>
                            }
                            {!data.invalid &&
                                <>
                                    <img src={downloaded} alt="" className="download"/>
                                    <span className='fileSuccessMessage'>Téléchargé</span>
                                </>
                            }
                            <button className="white basket" id={"basket"} onClick={() => removeFile(data.name)}>
                                <img src={basket} alt="BasketIcon"/>
                            </button>
                        </div>
                    )
                    }

                    <div className="containerButton">
                        {validFiles.length > 0 && unsupportedFiles.length === 0 && // Si n'y a pas de fichier non pris en charge, le button est enabled. On clique, on upload le/les fichier(s)
                            <button className="buttonModal orange" onClick={() => {
                                uploadFiles();
                                setShowModalNoRerender(false);
                            }}>
                                Ajouter
                            </button>
                        }
                        {validFiles.length === 0 || unsupportedFiles.length > 0 && // Si il n'y a pas de fichier valide ou s'il existe un fichier non supporté, on met le Button sur Disabled
                            <button className="buttonModal orange" disabled>
                                Ajouter
                            </button>
                        }
                        <button className="buttonModal white" onClick={() => setShowModalNoRerender(false)}>
                            Annuler
                        </button>
                    </div>
                </div>
                {/*<div className="modalPreview" ref={modalRef}>*/}
                {/*	<div className="overlay"></div>*/}
                {/*	<span className="close" onClick={(() => closeModal())}>X</span>*/}
                {/*	<div className="modal-image" ref={modalImageRef}></div>*/}
                {/*</div>*/}
            </div>
            <div className="upload-modal" ref={uploadModalRef}>
                <div className="overlay"></div>
                <div className="close" onClick={(() => closeUploadModal())}>X</div>
                <div className="progress-container">
                    <span ref={uploadRef}></span>
                    <div className="progress">
                        <div className="progress-bar" ref={progressRef}></div>
                    </div>
                </div>
            </div>
        </>
    );
};

UploadFile.propTypes = {
    idCase: PropTypes.string,
    setShowModalNoRerender: PropTypes.func,
    setSuccessUploadMess: PropTypes.func,
    setErrorUploadMess: PropTypes.func,
    setRedirection: PropTypes.func,
    postDocumentAsMessage: PropTypes.func,
    getMessages: PropTypes.func,
    getDocuments: PropTypes.func,
};

export default UploadFile;
